import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import Products from "@/pages/Products";
import Services from "@/pages/Services";

export default function Items() {
  return (
    <Tabs defaultValue="products">
      <div className="mb-2">
        <h1 className="font-heading text-3xl font-bold tracking-tight">Items</h1>
        <p className="text-sm text-muted-foreground mt-1">Products & services catalog</p>
      </div>
      <TabsList>
        <TabsTrigger value="products" data-testid="tab-items-products">Products</TabsTrigger>
        <TabsTrigger value="services" data-testid="tab-items-services">Services</TabsTrigger>
      </TabsList>
      <TabsContent value="products" className="mt-4"><Products /></TabsContent>
      <TabsContent value="services" className="mt-4"><Services /></TabsContent>
    </Tabs>
  );
}
